<template>
  <b-form-group
    label="Kiracı Kodu"
    label-for="tenant_code"
  >
    <b-form-input
      id="tenant_code"
      v-model="dataItem.tenants.tenant_code"
      readonly
      disabled
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'TenantCode',
  components: {
    BFormInput,
    BFormGroup,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
}
</script>
